<ion-grid class="confirmation-body p-10">

  <!-- Header Row -->
  <ion-row class="ion-align-items-center ion-justify-content-between mb-10 flex-wrap">

    <!-- Left Side: Toggle Section -->
    <ion-col size="12" size-md="6" class="ion-text-start ion-margin-bottom-sm">
      <div
        class="d-flex ion-align-items-center ion-justify-content-start"
        *ngIf="moduleName != 1 && moduleName != 2 && moduleName != 3 && moduleName != 'Manager'"
      >
        <label class="mr-10 fs-16 fw-500">Not Received Asset</label>

        <mat-slide-toggle
          class="mr-10"
          *ngIf="moduleName != 1 && moduleName != 2 && moduleName != 3"
          [(ngModel)]="isToggleOn"
          (change)="onChangeSwitch($event)"
        ></mat-slide-toggle>

        <label class="fs-16 fw-500">Received Asset</label>
      </div>
    </ion-col>

    <!-- Right Side: Action Icons -->
    <ion-col size="12" size-md="6" class="ion-text-end">
      <div class="d-flex ion-align-items-center ion-justify-content-end flex-wrap">

        <!-- Refresh Icon -->
        <span
          class="material-icons btn-reset fs-22 mr-10 icon-action" style="cursor:pointer;"
          title="Refresh"
          [class.clicked]="isClicked"
          (click)="resetGrid(); isClicked = true"
          (animationend)="isClicked = false"
        >
          refresh
        </span>

        
        <!-- Download Icon -->
       
           <span class="icon-download fs-20 material-icons cursor-pointer" style="cursor: pointer;"
          (click)="onBtExport('No Of Assets')">
          download
        </span>
        <!-- Close Icon -->

         <span [mat-dialog-close]
          class="fs-30 fs_24ForMobile material-icons icon-close" style="cursor: pointer;">
          close
        </span>
      </div>
    </ion-col>
  </ion-row>

  <!-- Table Section -->
  <ion-row>
    <ion-col size="12">
      <!-- Table Wrapper -->
      <div class="ag-wrapper">
        <!-- Table 1 -->
        <ag-grid-angular
          *ngIf="moduleName == 1"
          style="width: 100%; height: 420px;"
          class="ag-theme-quartz"
          (gridReady)="onGridReady($event)"
          [rowData]="allDataForDispay"
          [columnDefs]="columnDefs1"
          [pagination]="pagination"
          [paginationPageSize]="paginationPageSize"
          [paginationPageSizeSelector]="paginationPageSizeSelector"
          [defaultColDef]="defaultColDef"
          [gridOptions]="gridOptions"
          [localeText]="{ noRowsToShow: 'No Data Found' }"
        >
        </ag-grid-angular>

        <!-- Table 2 -->
        <ag-grid-angular
          *ngIf="moduleName == 2"
          style="width: 100%; height: 420px;"
          class="ag-theme-quartz"
          (gridReady)="onGridReady($event)"
          [rowData]="newAssetListingData"
          [columnDefs]="columnDefs2"
          [defaultColDef]="defaultColDef"
          [pagination]="pagination"
          [paginationPageSize]="paginationPageSize"
          [paginationPageSizeSelector]="paginationPageSizeSelector"
          [gridOptions]="gridOptions"
          [localeText]="{ noRowsToShow: 'No Data Found' }"
        >
        </ag-grid-angular>

        <!-- Table 3 -->
        <ag-grid-angular
          *ngIf="moduleName == 3"
          style="width: 100%; height: 420px;"
          class="ag-theme-quartz"
          (gridReady)="onGridReady($event)"
          [rowData]="repairedAsset"
          [columnDefs]="columnDefs3"
          [defaultColDef]="defaultColDef"
          [pagination]="pagination"
          [paginationPageSize]="paginationPageSize"
          [paginationPageSizeSelector]="paginationPageSizeSelector"
          [gridOptions]="gridOptions"
          [localeText]="{ noRowsToShow: 'No Data Found' }"
        >
        </ag-grid-angular>

        <!-- Table 4 -->
        <ag-grid-angular
          *ngIf="moduleName == 4"
          style="width: 100%; height: 420px;"
          class="ag-theme-quartz"
          (gridReady)="onGridReady($event)"
          [rowData]="returnAsset"
          [columnDefs]="columnDefs4"
          [defaultColDef]="defaultColDef"
          [pagination]="pagination"
          [paginationPageSize]="paginationPageSize"
          [paginationPageSizeSelector]="paginationPageSizeSelector"
          [gridOptions]="gridOptions"
          [localeText]="{ noRowsToShow: 'No Data Found' }"
        >
        </ag-grid-angular>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
